import React from "react"
import BasicTable from "Components/UI/Atoms/BasicTable"

const Wafers = ({ data }) => {
  return (
    <>
      <div style={{ display: "flex", margin: "2rem" }}>
        <BasicTable
          col={[
            { title: "", style: { width: "10px" } },
            { title: "Pieza", style: { width: "100px" } },
            { title: "Nº de oblea", style: { width: "100px" } },
            { title: "", style: { width: "10px" } }
          ]}
          size={"small"}
          rows={data.map((row) => {
            return {
              s: "",
              pieza: row.pieza,
              oblea: row.oblea,
              w: "" 
            }                  
          })}
          />
      </div>

    </>
  )
}

export default Wafers